import React, { MouseEventHandler } from 'react';
import { Alert, AlertDescription, AlertIcon, AlertTitle, CloseButton, Flex } from '@chakra-ui/react';
import { WarningIcon } from '@chakra-ui/icons';

// TODO: once icons have been chosen, implement them here
const icons = {
  neutral: WarningIcon,
  informative: WarningIcon,
  negative: WarningIcon,
};

export interface ToastBodyProps {
  variant?: string;
  title?: string;
  description?: string;
  showIcon?: boolean;
  isClosable?: boolean;
  onClose?: MouseEventHandler<HTMLButtonElement> | undefined;
}

const ToastBody = (props: ToastBodyProps) => {
  const Icon = props.showIcon && icons[props.variant ?? 'informative'];
  return (
    <Alert variant={props.variant}>
      {props.showIcon && <AlertIcon as={Icon} />}
      <Flex direction="column">
        {props.title && <AlertTitle mr={2}>{props.title}</AlertTitle>}
        {props.description && <AlertDescription mr={2}>{props.description}</AlertDescription>}
      </Flex>
      {props.isClosable && (
        <CloseButton
          h="9"
          w="9"
          color="gray.900"
          onClick={props.onClose}
          borderRadius="full"
          sx={{ svg: { h: '3', w: '3' } }}
          marginLeft="auto"
        />
      )}
    </Alert>
  );
};

export default ToastBody;
